// Keep the debounce function and the modified rangeSlider library code from the previous response

// Modified function to initialize the "Show More" button behavior for elements within a specific container
// This function should be called on the initial page load (for the whole document)
// and then specifically on the facet containers that were updated via AJAX.
function initShowMoreButtons(container = document) {
  // Find all facet lists within the specified container
  const facetLists = container.querySelectorAll(".facets__list");

  facetLists.forEach((el) => {
    const showMoreButton = el.querySelector('.list-menu__show-more');

    // Check if the button exists and if the list has more than 4 children
    if (showMoreButton && el.childElementCount > 4) {
      // Prevent adding duplicate listeners if this function is accidentally called twice on the same element
      // Replacing innerHTML should prevent this for the replaced elements, but this adds robustness.
      if (!showMoreButton.dataset.showMoreInitialized) {
         showMoreButton.addEventListener("click", function() {
           // Toggle the class on the facet list element
           if (el.classList.toggle("facets__list-long")) {
             showMoreButton.innerText = "- Minder opties";
           } else {
             showMoreButton.innerText = "+ Meer opties";
           }
         });
         // Mark the button as having its listener initialized
         showMoreButton.dataset.showMoreInitialized = 'true';
      }
    } else if (showMoreButton && el.childElementCount <= 4) {
        // If the button exists but is no longer needed (<= 4 items), ensure it's hidden or removed.
        // Your CSS or server-rendered HTML should ideally handle this, but JS could hide it.
        // For now, we just ensure the listener isn't added if the condition isn't met.
        // If the button *should* be hidden/removed, ensure your server template does that.
    }
  });
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');

// Nu ook op mobiel live feedback geven bij elke klik
facetForm.addEventListener('input', (event) => {
  if (event.target.closest('price-range')) return;
  this.debouncedOnSubmit(event);
});
// CRO FIX: Directe feedback + Submit voor Ratings/Prijzen
    facetForm.querySelectorAll('.facets__item a, .facets__item label:not(.facet-checkbox)').forEach(item => {
      item.addEventListener('click', (event) => {
        if (facetForm.id === 'FacetFiltersFormMobile') {
          // 1. Verwijder eerst 'active' van broertjes (voor het geval je van rating switcht)
          const parentList = item.closest('.facets__list');
          if (parentList) {
            parentList.querySelectorAll('.is-selected-loading').forEach(el => el.classList.remove('is-selected-loading'));
          }

          // 2. Voeg direct de 'loading/selected' class toe voor visuele bevestiging
          item.classList.add('is-selected-loading');

          // 3. Submit de boel
          setTimeout(() => {
            this.onSubmitHandler(event);
          }, 100);
        }
      });
    });

    // Add click handler for mobile "Bevestigen" button
    // Check for button inside form first
    const mobileSubmitButton = facetForm.querySelector('.facets-mobile-submit');
    if (mobileSubmitButton) {
      mobileSubmitButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.onSubmitHandler(event);
        const sidebar = document.getElementById('site-filters-sidebar');
        if (sidebar && sidebar.hide) {
          sidebar.hide();
        }
      });
    }

    // Use event delegation for button in sidebar footer (outside this element)
    const sidebar = this.closest('#site-filters-sidebar');
    if (sidebar) {
      sidebar.addEventListener('click', (event) => {
        if (event.target.closest('.sidebar__footer .facets-mobile-submit')) {
          event.preventDefault();
          // Create a synthetic event with target inside the form so onSubmitHandler works
          const syntheticEvent = {
            preventDefault: () => {},
            target: facetForm
          };
          this.onSubmitHandler(syntheticEvent);
          if (sidebar.hide) {
            sidebar.hide();
          }
        }
      });
    }

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

static renderPage(searchParams, event, updateURLHash = true) {
  FacetFiltersForm.searchParamsPrev = searchParams;

  if (FacetFiltersForm.abortController) {
    FacetFiltersForm.abortController.abort();
  }

  FacetFiltersForm.abortController = new AbortController();

  const sections = FacetFiltersForm.getSections();
  const gridWrapper = document.getElementById('main-collection-product-grid');

  if (gridWrapper) {
    gridWrapper.classList.add('loading');
  }

  sections.forEach((section) => {
    const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
    const filterDataUrl = element => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      : FacetFiltersForm.renderSectionFromFetch(url, event, FacetFiltersForm.abortController.signal);
  });

  if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
}

static renderSectionFromFetch(url, event, signal) {
  fetch(url, { signal })
    .then(response => response.text())
    .then((responseText) => {
      if (signal && signal.aborted) return;

      const html = responseText;

      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];

      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGrid(html);
      FacetFiltersForm.renderProductCount(html);
    })
    .catch((error) => {
      if (error.name !== 'AbortError') {
        console.error('Facet filtering failed:', error);
      }
    })
    .finally(() => {
      if (!signal || !signal.aborted) {
        const gridWrapper = document.getElementById('main-collection-product-grid');

        if (gridWrapper) {
          gridWrapper.classList.remove('loading');
        }
      }
    });
}

static renderSectionFromCache(filterDataUrl, event) {
  const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

  FacetFiltersForm.renderFilters(html, event);
  FacetFiltersForm.renderProductGrid(html);
  FacetFiltersForm.renderProductCount(html);

  const gridWrapper = document.getElementById('main-collection-product-grid');

  if (gridWrapper) {
    gridWrapper.classList.remove('loading');
  }
}

  static renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('CollectionProductGrid').innerHTML;
    document.getElementById('CollectionProductGrid').innerHTML = innerHTML;
    document.getElementById('CollectionProductGrid').querySelectorAll('template').forEach(elm=>{
      elm.closest('form')?.append(elm.content.cloneNode(true));
    })
  }

  static renderProductCount(html) {
    const countEl = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductCount');
    if ( countEl ) {
      document.querySelectorAll('#CollectionProductCount').forEach(elm=>{
        elm.innerHTML = countEl.innerHTML;
      });
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

   const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');

const currentFilter = event ? event.target.closest('.js-filter') : undefined;
const isPriceRangeUpdate = !!event?.target?.closest('price-range') || currentFilter?.classList.contains('js-filter--price-range');

const matchesIndex = (element) => {
  return currentFilter ? (element.dataset.index === currentFilter.dataset.index && !element.hasAttribute('data-and-operator')) : false;
};

/*
  Belangrijk:
  Als de prijsfilter de update triggert, vervangen we geen andere filterblokken.
  Anders kan Shopify opties zoals Druif uit de HTML-response halen, waardoor ze verdwijnen.
*/
const facetsToRender = isPriceRangeUpdate
  ? []
  : Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));

const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      // Find the existing element on the page that corresponds to this updated facet
        const existingElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);

        if (existingElement) {
             // Replacing innerHTML removes old elements and creates new ones.
             // For custom elements like <price-range> and <facet-remove> within this HTML,
             // their disconnectedCallback should run, then connectedCallback for the new ones.
            existingElement.innerHTML = element.innerHTML;

             // **Re-initialize custom elements (like PriceRange) within the replaced HTML**
             // This is necessary because connectedCallback might need a push or
             // to ensure the initialization logic runs consistently after innerHTML replacement.
             // Query for custom elements *within* the element whose HTML was just replaced.
            existingElement.querySelectorAll('price-range').forEach(priceRangeEl => {
                 // Call the initialization method if it exists
                if (typeof priceRangeEl.initializePriceRange === 'function') {
                   priceRangeEl.initializePriceRange();
                } else if (typeof priceRangeEl.connectedCallback === 'function') {
                    // Fallback to calling connectedCallback if initializePriceRange is not a public method
                    priceRangeEl.connectedCallback();
                }
            });
            // Re-initialize any other custom elements that might need it (like facet-remove, although its constructor might be enough)
            existingElement.querySelectorAll('facet-remove').forEach(facetRemoveEl => {
                 // For facet-remove, the constructor attaching the click listener on creation
                 // should be sufficient after innerHTML replaces the element. No extra step needed unless issues arise.
            });


            // *** IMPORTANT FIX: Re-initialize "Show More" buttons ONLY for THIS replaced facet ***
            initShowMoreButtons(existingElement); // Run the initialization function on the replaced container

        }

    });

     // The facet that triggered the update (countsToRender) was NOT replaced.
     // Its existing custom elements (<price-range>, <facet-remove>) and their listeners (including "Meer opties" if applicable)
     // from the initial page load or a previous update are still present and should still be working.
     // We must NOT run initShowMoreButtons(event.target.closest('.js-filter')) here as it would add a duplicate listener.


    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    // REMOVED: Do NOT call facetsEventListeners() or initShowMoreButtons(document) here.
     // Listeners have already been initialized on initial load,
     // and selectively re-initialized above for the replaced facets.
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      if ( document.querySelector(selector) ) {
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      }
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const countElementSelectors = ['.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);
      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.abortController = null;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
    this.submitTimer = null;
    this.bubbleTimer = null;
    this.activeDrag = null;
  }

  connectedCallback() {
    this.initializePriceRange();
  }

  initializePriceRange() {
    this.cleanUpEvents();

    const inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    const inputMax = this.querySelector('input[name="filter.v.price.lte"]');

    if (!inputMin || !inputMax) return;

    const originalMin = Math.max(
      1,
      this.getNumber(
        inputMin.getAttribute('data-original-min') ||
        inputMin.getAttribute('min') ||
        inputMin.getAttribute('placeholder') ||
        '0'
      )
    );

    const originalMax = this.getNumber(
      inputMax.getAttribute('data-original-max') ||
      inputMax.getAttribute('max') ||
      inputMax.getAttribute('placeholder') ||
      '100'
    );

    if (!Number.isFinite(originalMin) || !Number.isFinite(originalMax) || originalMax <= originalMin) return;

    inputMin.setAttribute('data-original-min', originalMin.toString());
    inputMax.setAttribute('data-original-max', originalMax.toString());

    inputMin.setAttribute('min', originalMin.toString());
    inputMin.setAttribute('max', originalMax.toString());
    inputMax.setAttribute('min', originalMin.toString());
    inputMax.setAttribute('max', originalMax.toString());

    inputMin.inputMode = 'decimal';
    inputMax.inputMode = 'decimal';

    const priceWrapper = this.querySelector('.facets__price') || this;

    priceWrapper.classList.add('facets__price--custom-range');

    this.closest('.facets__display')?.classList.add('facets__display--price-range');
    this.closest('.js-filter')?.classList.add('js-filter--price-range');

    Array.from(priceWrapper.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().toLowerCase() === 'naar') {
        node.textContent = '';
      }

      if (
        node.nodeType === Node.ELEMENT_NODE &&
        !node.classList.contains('field') &&
        !node.classList.contains('facets-price-range-slider') &&
        node.textContent.trim().toLowerCase() === 'naar'
      ) {
        node.hidden = true;
      }
    });

    let sliderContainer = priceWrapper.querySelector('[data-js-price-range-slider]');

    if (!sliderContainer) {
      sliderContainer = document.createElement('div');
      sliderContainer.setAttribute('data-js-price-range-slider', '');
    }

    priceWrapper.prepend(sliderContainer);

    sliderContainer.className = 'facets-price-range-slider';
    sliderContainer.innerHTML = `
      <div class="facets-price-range-slider__track">
        <div class="facets-price-range-slider__range"></div>
      </div>

      <div class="facets-price-range-slider__bubble facets-price-range-slider__bubble--min" aria-hidden="true"></div>
      <div class="facets-price-range-slider__bubble facets-price-range-slider__bubble--max" aria-hidden="true"></div>

      <button
        class="facets-price-range-slider__thumb facets-price-range-slider__thumb--min"
        type="button"
        aria-label="Minimum prijs"
      ></button>

      <button
        class="facets-price-range-slider__thumb facets-price-range-slider__thumb--max"
        type="button"
        aria-label="Maximum prijs"
      ></button>
    `;

    const track = sliderContainer.querySelector('.facets-price-range-slider__track');
    const minThumb = sliderContainer.querySelector('.facets-price-range-slider__thumb--min');
    const maxThumb = sliderContainer.querySelector('.facets-price-range-slider__thumb--max');
    const minBubble = sliderContainer.querySelector('.facets-price-range-slider__bubble--min');
    const maxBubble = sliderContainer.querySelector('.facets-price-range-slider__bubble--max');

    const sliderMin = 0;
    const sliderMax = 1000;
    const priceSliderCurve = 2.2;

    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    const priceFieldBoxes = priceWrapper.querySelectorAll('.field');

    priceFieldBoxes.forEach((field, index) => {
      const labelText = index === 0 ? 'Min.' : 'Max.';

      field.setAttribute('data-price-label', labelText);

      const label = field.querySelector('.field__label');
      if (label) {
        label.textContent = labelText;
      }

      field.addEventListener('click', () => {
        const input = field.querySelector('input');
        if (input) input.focus();
      }, { signal });
    });

    const getInputValues = () => {
      const minRaw = inputMin.value.trim();
      const maxRaw = inputMax.value.trim();

      const minValue = minRaw === ''
        ? originalMin
        : this.clamp(this.getNumber(minRaw, originalMin), originalMin, originalMax);

      const maxValue = maxRaw === ''
        ? originalMax
        : this.clamp(this.getNumber(maxRaw, originalMax), originalMin, originalMax);

      return {
        minRaw,
        maxRaw,
        minValue,
        maxValue
      };
    };

    const initialValues = getInputValues();

    let minPosition = initialValues.minRaw === ''
      ? sliderMin
      : this.priceToSlider(initialValues.minValue, originalMin, originalMax, priceSliderCurve);

    let maxPosition = initialValues.maxRaw === ''
      ? sliderMax
      : this.priceToSlider(initialValues.maxValue, originalMin, originalMax, priceSliderCurve);

    const updateVisuals = () => {
      const leftPercentage = (minPosition / sliderMax) * 100;
      const rightPercentage = 100 - ((maxPosition / sliderMax) * 100);
      const maxPercentage = 100 - rightPercentage;

      const minDisplayValue = this.sliderToPrice(minPosition, originalMin, originalMax, priceSliderCurve);
      const maxDisplayValue = this.sliderToPrice(maxPosition, originalMin, originalMax, priceSliderCurve);

      sliderContainer.style.setProperty('--price-range-left', `${leftPercentage}%`);
      sliderContainer.style.setProperty('--price-range-right', `${rightPercentage}%`);

      minThumb.style.left = `${leftPercentage}%`;
      maxThumb.style.left = `${maxPercentage}%`;

      minThumb.setAttribute('aria-valuemin', originalMin.toString());
      minThumb.setAttribute('aria-valuemax', originalMax.toString());
      minThumb.setAttribute('aria-valuenow', this.formatValue(minDisplayValue));

      maxThumb.setAttribute('aria-valuemin', originalMin.toString());
      maxThumb.setAttribute('aria-valuemax', originalMax.toString());
      maxThumb.setAttribute('aria-valuenow', this.formatValue(maxDisplayValue));

      if (minBubble && maxBubble) {
        minBubble.style.left = `${leftPercentage}%`;
        maxBubble.style.left = `${maxPercentage}%`;

        minBubble.textContent = `€${this.formatValue(minDisplayValue)}`;
        maxBubble.textContent = `€${this.formatValue(maxDisplayValue)}`;
      }
    };

    const syncInputsFromPositions = () => {
      const minValue = this.sliderToPrice(minPosition, originalMin, originalMax, priceSliderCurve);
      const maxValue = this.sliderToPrice(maxPosition, originalMin, originalMax, priceSliderCurve);

      inputMin.value = minPosition <= sliderMin ? '' : this.formatValue(minValue);
      inputMax.value = maxPosition >= sliderMax ? '' : this.formatValue(maxValue);

      updateVisuals();
    };

    const syncPositionsFromInputs = (changedInput, writeInputs = false) => {
      const values = getInputValues();

      let nextMinPosition = values.minRaw === ''
        ? sliderMin
        : this.priceToSlider(values.minValue, originalMin, originalMax, priceSliderCurve);

      let nextMaxPosition = values.maxRaw === ''
        ? sliderMax
        : this.priceToSlider(values.maxValue, originalMin, originalMax, priceSliderCurve);

      if (nextMinPosition > nextMaxPosition) {
        if (changedInput === inputMin) {
          nextMaxPosition = nextMinPosition;
        } else {
          nextMinPosition = nextMaxPosition;
        }
      }

      minPosition = this.clamp(nextMinPosition, sliderMin, sliderMax);
      maxPosition = this.clamp(nextMaxPosition, sliderMin, sliderMax);

      if (writeInputs) {
        const minValue = this.sliderToPrice(minPosition, originalMin, originalMax, priceSliderCurve);
        const maxValue = this.sliderToPrice(maxPosition, originalMin, originalMax, priceSliderCurve);

        if (changedInput === inputMin || values.minRaw !== '') {
          inputMin.value = minPosition <= sliderMin ? '' : this.formatValue(minValue);
        }

        if (changedInput === inputMax || values.maxRaw !== '') {
          inputMax.value = maxPosition >= sliderMax ? '' : this.formatValue(maxValue);
        }
      }

      updateVisuals();
    };

    const getPositionFromPointer = (event) => {
      const rect = track.getBoundingClientRect();

      if (!rect.width) return sliderMin;

      const ratio = (event.clientX - rect.left) / rect.width;

      return Math.round(this.clamp(ratio, 0, 1) * sliderMax);
    };

    const showActiveBubble = (bubble) => {
      if (!bubble || !minBubble || !maxBubble) return;

      clearTimeout(this.bubbleTimer);

      minBubble.classList.remove('is-active');
      maxBubble.classList.remove('is-active');

      bubble.classList.add('is-active');
      sliderContainer.classList.add('is-interacting');
    };

    const hideBubbles = () => {
      if (!minBubble || !maxBubble) return;

      clearTimeout(this.bubbleTimer);

      this.bubbleTimer = setTimeout(() => {
        sliderContainer.classList.remove('is-interacting');
        minBubble.classList.remove('is-active');
        maxBubble.classList.remove('is-active');
      }, 650);
    };

    const moveThumb = (thumbType, position, submit = true) => {
      const nextPosition = this.clamp(position, sliderMin, sliderMax);

      if (thumbType === 'min') {
        minPosition = Math.min(nextPosition, maxPosition);
        showActiveBubble(minBubble);
      } else {
        maxPosition = Math.max(nextPosition, minPosition);
        showActiveBubble(maxBubble);
      }

      syncInputsFromPositions();

      if (submit) {
        this.scheduleSubmit(thumbType === 'min' ? inputMin : inputMax);
      }
    };

    const startDrag = (thumbType, event) => {
      event.preventDefault();

      this.activeDrag = thumbType;
      sliderContainer.classList.add('is-dragging');

      moveThumb(thumbType, getPositionFromPointer(event), false);
    };

    const stopDrag = () => {
      if (!this.activeDrag) return;

      const targetInput = this.activeDrag === 'min' ? inputMin : inputMax;

      this.activeDrag = null;
      sliderContainer.classList.remove('is-dragging');

      this.scheduleSubmit(targetInput);
      hideBubbles();
    };

    window.addEventListener('pointermove', (event) => {
      if (!this.activeDrag) return;

      event.preventDefault();
      moveThumb(this.activeDrag, getPositionFromPointer(event), false);
    }, { signal });

    window.addEventListener('pointerup', stopDrag, { signal });
    window.addEventListener('pointercancel', stopDrag, { signal });

    minThumb.addEventListener('pointerdown', (event) => {
      startDrag('min', event);
    }, { signal });

    maxThumb.addEventListener('pointerdown', (event) => {
      startDrag('max', event);
    }, { signal });

    sliderContainer.addEventListener('pointerdown', (event) => {
      if (event.target.closest('.facets-price-range-slider__thumb')) return;

      const position = getPositionFromPointer(event);
      const minDistance = Math.abs(position - minPosition);
      const maxDistance = Math.abs(position - maxPosition);

      startDrag(minDistance <= maxDistance ? 'min' : 'max', event);
    }, { signal });

    const handleThumbKeydown = (thumbType, event) => {
      const smallStep = 10;
      const largeStep = 50;
      let nextPosition = thumbType === 'min' ? minPosition : maxPosition;

      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        nextPosition -= smallStep;
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        nextPosition += smallStep;
      } else if (event.key === 'PageDown') {
        nextPosition -= largeStep;
      } else if (event.key === 'PageUp') {
        nextPosition += largeStep;
      } else if (event.key === 'Home') {
        nextPosition = sliderMin;
      } else if (event.key === 'End') {
        nextPosition = sliderMax;
      } else {
        return;
      }

      event.preventDefault();
      moveThumb(thumbType, nextPosition, true);
    };

    minThumb.addEventListener('focus', () => {
      showActiveBubble(minBubble);
    }, { signal });

    maxThumb.addEventListener('focus', () => {
      showActiveBubble(maxBubble);
    }, { signal });

    minThumb.addEventListener('blur', hideBubbles, { signal });
    maxThumb.addEventListener('blur', hideBubbles, { signal });

    minThumb.addEventListener('keydown', (event) => {
      handleThumbKeydown('min', event);
    }, { signal });

    maxThumb.addEventListener('keydown', (event) => {
      handleThumbKeydown('max', event);
    }, { signal });

inputMin.addEventListener('input', (event) => {
  event.stopPropagation();

  if (this.isManualPriceRangeInvalid(false)) {
    return;
  }

  syncPositionsFromInputs(inputMin, false);
}, { signal });

inputMax.addEventListener('input', (event) => {
  event.stopPropagation();

  if (this.isManualPriceRangeInvalid(false)) {
    return;
  }

  syncPositionsFromInputs(inputMax, false);
}, { signal });

    inputMin.addEventListener('change', (event) => {
  event.stopPropagation();

  if (this.isManualPriceRangeInvalid(true)) {
    return;
  }

  syncPositionsFromInputs(inputMin, true);
  this.scheduleSubmit(inputMin);
}, { signal });

inputMax.addEventListener('change', (event) => {
  event.stopPropagation();

  if (this.isManualPriceRangeInvalid(true)) {
    return;
  }

  syncPositionsFromInputs(inputMax, true);
  this.scheduleSubmit(inputMax);
}, { signal });

    updateVisuals();
  }

  isManualPriceRangeInvalid(showMessage = true) {
  const inputMin = this.querySelector('input[name="filter.v.price.gte"]');
  const inputMax = this.querySelector('input[name="filter.v.price.lte"]');
  const priceWrapper = this.querySelector('.facets__price') || this;

  if (!inputMin || !inputMax || !priceWrapper) return false;

  const minRaw = inputMin.value.trim();
  const maxRaw = inputMax.value.trim();

  const minValue = this.getNumber(minRaw, NaN);
  const maxValue = this.getNumber(maxRaw, NaN);

  const isInvalid =
    minRaw !== '' &&
    maxRaw !== '' &&
    Number.isFinite(minValue) &&
    Number.isFinite(maxValue) &&
    minValue >= maxValue;

  priceWrapper.classList.toggle('is-invalid-price-range', isInvalid);
  inputMin.toggleAttribute('aria-invalid', isInvalid);
  inputMax.toggleAttribute('aria-invalid', isInvalid);

  if (isInvalid && showMessage) {
    priceWrapper.setAttribute('data-price-error', 'De maximale prijs moet hoger zijn dan de minimale prijs.');
  } else if (!isInvalid) {
    priceWrapper.removeAttribute('data-price-error');
  }

  return isInvalid;
}

  scheduleSubmit(targetInput) {
  clearTimeout(this.submitTimer);

  if (this.isManualPriceRangeInvalid(true)) {
    return;
  }

  this.submitTimer = setTimeout(() => {
    if (this.isManualPriceRangeInvalid(true)) {
      return;
    }

    const facetForm = this.closest('facet-filters-form');

    if (!facetForm) return;

    facetForm.onSubmitHandler({
      target: targetInput,
      preventDefault: () => {}
    });
  }, 200);
}

  getPriceScaleSegments(min, max) {
  if (max <= min) {
    return [
      {
        start: min,
        end: max,
        startRatio: 0,
        endRatio: 1
      }
    ];
  }

  const segmentCandidates = [
    {
      start: min,
      end: Math.min(max, 40),
      weight: 0.60
    },
    {
      start: Math.max(min, 40),
      end: Math.min(max, 100),
      weight: 0.25
    },
    {
      start: Math.max(min, 100),
      end: max,
      weight: 0.15
    }
  ].filter((segment) => segment.end > segment.start);

  if (segmentCandidates.length === 1) {
    return [
      {
        start: segmentCandidates[0].start,
        end: segmentCandidates[0].end,
        startRatio: 0,
        endRatio: 1
      }
    ];
  }

  const totalWeight = segmentCandidates.reduce((sum, segment) => sum + segment.weight, 0);
  let currentRatio = 0;

  return segmentCandidates.map((segment, index) => {
    const segmentShare = segment.weight / totalWeight;
    const startRatio = currentRatio;
    const endRatio = index === segmentCandidates.length - 1
      ? 1
      : currentRatio + segmentShare;

    currentRatio = endRatio;

    return {
      start: segment.start,
      end: segment.end,
      startRatio,
      endRatio
    };
  });
}

sliderToPrice(position, min, max, curve = 2.2) {
  const ratio = this.clamp(Number(position) / 1000, 0, 1);
  const segments = this.getPriceScaleSegments(min, max);
  const segment = segments.find((item) => ratio <= item.endRatio) || segments[segments.length - 1];

  if (!segment || segment.end <= segment.start || segment.endRatio <= segment.startRatio) {
    return this.roundSliderPrice(min);
  }

  const segmentRatio = (ratio - segment.startRatio) / (segment.endRatio - segment.startRatio);
  const value = segment.start + ((segment.end - segment.start) * this.clamp(segmentRatio, 0, 1));

  return this.roundSliderPrice(value);
}

priceToSlider(price, min, max, curve = 2.2) {
  if (max <= min) return 0;

  const value = this.clamp(Number(price), min, max);
  const segments = this.getPriceScaleSegments(min, max);
  const segment = segments.find((item) => value <= item.end) || segments[segments.length - 1];

  if (!segment || segment.end <= segment.start || segment.endRatio <= segment.startRatio) {
    return 0;
  }

  const segmentRatio = (value - segment.start) / (segment.end - segment.start);
  const ratio = segment.startRatio + (this.clamp(segmentRatio, 0, 1) * (segment.endRatio - segment.startRatio));

  return Math.round(this.clamp(ratio, 0, 1) * 1000);
}

  roundSliderPrice(value) {
    if (value < 50) return Math.round(value);
    if (value < 150) return Math.round(value / 5) * 5;

    return Math.round(value / 10) * 10;
  }

  getNumber(value, fallback = 0) {
    if (value === null || value === undefined || value === '') return fallback;

    const number = Number(String(value).replace(',', '.'));

    return Number.isFinite(number) ? number : fallback;
  }

  clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  formatValue(value) {
    if (Number.isInteger(value)) return value.toString();

    return value.toFixed(2).replace(/\.?0+$/, '');
  }

  cleanUpEvents() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }

    if (this.submitTimer) {
      clearTimeout(this.submitTimer);
      this.submitTimer = null;
    }

    if (this.bubbleTimer) {
      clearTimeout(this.bubbleTimer);
      this.bubbleTimer = null;
    }

    this.activeDrag = null;
  }

  disconnectedCallback() {
    this.cleanUpEvents();
  }
}

customElements.define('price-range', PriceRange);

// *** INITIAL CALL ONLY ***
// Initialize "Show More" buttons for all facet lists on the initial page load
document.addEventListener("DOMContentLoaded", function() {
  initShowMoreButtons(document);
});